/** Default copy when invite API returns a non-string body without a message field. */
export const DEFAULT_INVITE_SUCCESS_MESSAGE = 'Invitation email sent successfully.';

/**
 * Normalizes Redux notification payloads (string, object, Immutable) for display.
 */
export function formatNotificationMessage(msg) {
  if (msg == null || msg === 'loading') {
    return '';
  }
  if (typeof msg === 'string') {
    return msg;
  }
  if (typeof msg === 'object') {
    if (typeof msg.message === 'string') {
      return msg.message;
    }
    if (typeof msg.get === 'function') {
      const nested = msg.get('message');
      if (nested) {
        return String(nested);
      }
    }
  }
  return String(msg);
}

export function hasNotificationMessage(msg) {
  return Boolean(formatNotificationMessage(msg));
}

export function formatInviteSuccessMessage(response) {
  const formatted = formatNotificationMessage(response);
  return formatted || DEFAULT_INVITE_SUCCESS_MESSAGE;
}
